// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2JbX5","label":"Labeled_label__2yjfZ","divider":"Labeled_divider__2xxAU"};